import React, { useState } from 'react';
import { trackPhoneClick, trackWhatsAppClick, trackEmailInteraction } from '../utilities/trackingUtils';
import './ContactSection.css';

const ContactSection = () => {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactForm({ ...contactForm, [name]: value });
  };

  const handlePhoneClick = (e) => {
    e.preventDefault();
    trackPhoneClick('+917816088532', 'Contact Section Phone Link');
    window.location.href = 'tel:+917816088532';
  };

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    trackWhatsAppClick('Contact Section WhatsApp Button');
    window.open('https://wa.me/917816088532', '_blank');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Track email interaction
    trackEmailInteraction(contactForm.email);
    
    // Format message for WhatsApp
    const message = `Contact Inquiry:%0A
Name: ${contactForm.name}%0A
Email: ${contactForm.email}%0A
Message: ${contactForm.message}`;
    
    // Track WhatsApp contact
    trackWhatsAppClick('Contact Form WhatsApp');
    
    // Redirect to WhatsApp with formatted message
    window.open(`https://wa.me/917816088532?text=${message}`, '_blank');
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-header">
          <h2>Contact Us</h2>
          <div className="underline"></div>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="info-text">
                <h4>Location</h4>
                <p>12-5-3, MadhuraHouse, Vijayapuri Colony, lalaput road, Tarnaka</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <i className="fas fa-phone-alt"></i>
              </div>
              <div className="info-text">
                <h4>Phone</h4>
                <a href="tel:+917816088532" onClick={handlePhoneClick} className="contact-link">+91 7816088532</a>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <i className="fab fa-whatsapp"></i>
              </div>
              <div className="info-text">
                <h4>WhatsApp</h4>
                <button onClick={handleWhatsAppClick} className="contact-link" style={{background: 'none', border: 'none', cursor: 'pointer', padding: 0}}>
                  +91 7816088532
                </button>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="info-text">
                <h4>Email</h4>
                <a href="mailto:support@examguidetutorials.com" className="contact-link">support@examguidetutorials.com</a>
              </div>
            </div>
            
          </div>
          
          <div className="contact-form-container">
            <div className="card">
              <h3>Send us a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="contact-name">Your Name</label>
                  <input 
                    type="text" 
                    id="contact-name" 
                    name="name" 
                    placeholder="Enter your name" 
                    value={contactForm.name} 
                    onChange={handleChange} 
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="contact-email">Your Email</label>
                  <input 
                    type="email" 
                    id="contact-email" 
                    name="email" 
                    placeholder="e.g., example@email.com" 
                    value={contactForm.email} 
                    onChange={handleChange} 
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="contact-message">Your Message</label>
                  <textarea 
                    id="contact-message" 
                    name="message" 
                    rows="5" 
                    placeholder="Your message here" 
                    value={contactForm.message} 
                    onChange={handleChange} 
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="btn">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 